<template>
    <div class="social" v-if="type == 'messenger'" :class="customClass">
        <a
            href="https://wa.me/79399006343"
            @click="sendClick('messenger')"
            target="_blank"
            rel="nofollow noopener noreferrer"
            class="social__item">
            <svg-icon width="16" height="16" name="whatsup"></svg-icon>
            <span>what’s up</span>
            <span
                class="color-text_3 text_11"
                v-if="showUrl && $store.getters['globalvars/getLang'] && $store.getters['globalvars/getLang'] === 'ru'"
                >+7 939 900 63 43</span
            >
        </a>
        <a
            href="https://t.me/pps_clients"
            @click="sendClick('messenger')"
            target="_blank"
            rel="nofollow noopener noreferrer"
            class="social__item">
            <svg-icon width="16" height="16" name="telegram"></svg-icon>
            <span>telegram</span>
            <span class="color-text_3 text_11" v-if="showUrl">@pps_clients</span>
        </a>
        <a
            href="https://max.ru/id7702704924_bot"
            @click="sendClick('messenger')"
            target="_blank"
            rel="nofollow noopener noreferrer"
            class="social__item">
            <svg-icon width="16" height="16" name="max"></svg-icon>
            <span>max</span>
            <span class="color-text_3 text_11" v-if="showUrl">@id7702704924_bot</span>
        </a>
    </div>
    <div v-else>
        <div class="social-text social-text--title">{{ $t("our_socials") }}</div>
        <div class="social social-text" :class="customClass">
            <a
                href="https://t.me/pps_brand"
                @click="sendClick('messenger')"
                target="_blank"
                rel="nofollow noopener noreferrer"
                class="social__item">
                <svg-icon width="16" height="16" name="telegram"></svg-icon>
                <span>telegram</span>
                <span class="color-text_3 text_11" v-if="showUrl">@pps_brand</span>
            </a>
            <!-- <a
                href="https://vk.com/ppsbrand"
                @click="sendClick('social')"
                target="_blank"
                rel="nofollow noopener noreferrer"
                class="social__item">
                <svg-icon width="16" height="16" name="vk--16"></svg-icon>
                <span>vkontakte</span>
                <span class="color-text_3 text_11" v-if="showUrl">pps_brand</span>
            </a> -->
            <!--<a href="https://www.facebook.com/p.p.s.brand" @click="sendClick('social')" class="social__item" target="_blank" rel="nofollow noopener noreferrer">
                <svg-icon width="16" height="16" name="facebook"></svg-icon>
                <span>facebook</span>
                <span class="color-text_3 text_11" v-if="showUrl">facebook.com/p.p.s.brand</span>
            </a>
            <a href="https://www.instagram.com/p.p.s.brand/" @click="sendClick('social')" target="_blank" rel="nofollow noopener noreferrer" class="social__item">
                <svg-icon width="16" height="16" name="instagram"></svg-icon>
                <span>instagram</span>
                <span class="color-text_3 text_11" v-if="showUrl">@p.p.s.brand</span>
            </a>-->
            <!-- <a href="#" class="social__item" target="_blank" rel="nofollow">
                <svg-icon width="16" height="16" name="pinterest"></svg-icon>
                <span>pinterest</span>
                <span class="color-text_3 text_11"></span>
            </a> -->
        </div>
    </div>
</template>
<script>
export default {
    name: "SocialLinks",
    props: ["type", "customClass", "showUrl"],
    methods: {
        sendClick(type) {
            // ga("send", "event", type, "click");
        },
    },
};
</script>
<style lang="less" scoped>
.social {
    display: flex;
    flex-wrap: wrap;
    gap: 22px 44px;
    @media @sm {
        gap: 22px 51px;
    }
    &.short-margin {
        gap: 12px 24px;
    }

    &__item {
        display: flex;
        align-items: flex-end;
        gap: 4px;
        span {
            + span {
                margin-left: 6px;
                &:before {
                    content: "/";
                    display: inline-block;
                    margin-right: 8px;
                }
            }
        }
    }
    &--vertical {
        flex-direction: column;
        gap: 24px;
        &.social--sm-margin {
            gap: 16px;
        }
    }
    &-text {
        padding-top: 8px;
        @media @sm {
            padding-top: 0;
        }
        &--title {
            margin-bottom: 24px;
        }
    }
}
</style>
